// Admin authentication & profile
export const SET_ADMIN = "SET_ADMIN";
export const UNSET_ADMIN = "UNSET_ADMIN";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SIGNUP_ADMIN = "SIGNUP_ADMIN";

// Admin dialog
export const OPEN_ADMIN_DIALOG = "OPEN_ADMIN_DIALOG";
export const CLOSE_ADMIN_DIALOG = "CLOSE_ADMIN_DIALOG";
export const TOGGLE_MANAGEMENT_DIALOG = "TOGGLE_MANAGEMENT_DIALOG";

// Admin list & management
export const SET_ADMINS = "SET_ADMINS"; // Set all admins
export const ACTIVE_INACTIVE_ADMIN = "ACTIVE_INACTIVE_ADMIN"; // active inactive admin
export const ADMIN_ERROR = "ADMIN_ERROR"; // Error handling for admins
